import { render, staticRenderFns } from "./SoundUpload.vue?vue&type=template&id=51061df2&scoped=true"
import script from "./SoundUpload.vue?vue&type=script&lang=js"
export * from "./SoundUpload.vue?vue&type=script&lang=js"
import style0 from "./SoundUpload.vue?vue&type=style&index=0&id=51061df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51061df2",
  null
  
)

export default component.exports